
export default function Header(props){
    return(
        <header className="web-header">
            <div className="title-container">
                <h1>Defiant Jazz</h1>
            </div>
            
        </header>
    )
}